import { UserProductFeatureSummaryModelDto as BoProductFeatureSummaryModelDto } from '@treasury/api/bo';
import { UserProductFeatureSummaryModelDto as ConsumerProductFeatureSummaryModelDto } from '@treasury/api/channel';
import { DomainEntity } from '../../../shared';

const defaultCompanyUserProductFeatureSummary:
    | BoProductFeatureSummaryModelDto
    | ConsumerProductFeatureSummaryModelDto = {
    userId: 0,
    changedUserInformation: false,
    changedAccountAccess: false,
    hasAch: false,
    changedAchEntitlements: false,
    changedAchUserLimits: false,
    hasStandardPosPay: false,
    hasSsoPosPay: false,
    changedStandardPosPayEntitlements: false,
    changedSsoPosPayUserSettings: false,
    hasInformationReporting: false,
    changedInformationReportingEntitlements: false,
    hasInternalTransfers: false,
    changedInternalTransfersEntitlements: false,
    changedInternalTransfersUserLimits: false,
    hasWireTransfers: false,
    hasWireTransfersDomestic: false,
    hasWireTransfersInternational: false,
    changedWireTransfersEntitlements: false,
    changedWireTransfersUserLimits: false,
    hasWireTransfersDli: false,
    changedWireTransfersDliEntitlements: false,
    changedWireTransfersDliUserLimits: false,
    hasStopPayment: false,
    changedStopPaymentEntitlements: false,
    changedTimeAccess: false,
    changedIpRestrictions: false,
    hasIntegratedServices: false,
    changedIntegratedServices: false,
    hasReceivables: false,
    changedReceivables: false,
    hasAccountReconciliationReporting: false,
    changedAccountReconciliationReporting: false,
};

export class CompanyUserProductFeatureSummary extends DomainEntity<
    BoProductFeatureSummaryModelDto | ConsumerProductFeatureSummaryModelDto
> {
    public get userId() {
        return this.dto.userId;
    }

    public get changedUserInformation() {
        return this.dto.changedUserInformation;
    }

    public get changedAccountAccess() {
        return this.dto.changedAccountAccess;
    }

    public get changedAchEntitlements() {
        return this.dto.changedAchEntitlements;
    }

    public get changedAchUserLimits() {
        return this.dto.changedAchUserLimits;
    }

    public get changedStandardPosPayEntitlements() {
        return this.dto.changedStandardPosPayEntitlements;
    }

    public get changedSsoPosPayUserSettings() {
        return this.dto.changedSsoPosPayUserSettings;
    }

    public get changedInformationReportingEntitlements() {
        return this.dto.changedInformationReportingEntitlements;
    }

    public get changedInternalTransfersEntitlements() {
        return this.dto.changedInternalTransfersEntitlements;
    }

    public get changedInternalTransfersUserLimits() {
        return this.dto.changedInternalTransfersUserLimits;
    }

    public get changedWireTransfersEntitlements() {
        return this.dto.changedWireTransfersEntitlements;
    }

    public get changedWireTransfersUserLimits() {
        return this.dto.changedWireTransfersUserLimits;
    }

    public get changedStopPaymentEntitlements() {
        return this.dto.changedStopPaymentEntitlements;
    }

    public get changedTimeAccess() {
        return this.dto.changedTimeAccess;
    }

    public get changedIpRestrictions() {
        return this.dto.changedIpRestrictions;
    }

    public get changedReceivables() {
        return this.dto.changedReceivables;
    }

    public get changedAccountReconciliationReporting() {
        return this.dto.changedAccountReconciliationReporting;
    }

    public get hasAch() {
        return this.dto.hasAch;
    }

    public get hasStandardPosPay() {
        return this.dto.hasStandardPosPay;
    }

    public get hasSsoPosPay() {
        return this.dto.hasSsoPosPay;
    }

    public get hasInformationReporting() {
        return this.dto.hasInformationReporting;
    }

    public get hasInternalTransfers() {
        return this.dto.hasInternalTransfers;
    }

    public get hasWireTransfers() {
        return this.dto.hasWireTransfers;
    }

    public get hasWireTransfersDomestic() {
        return this.dto.hasWireTransfersDomestic;
    }

    public get hasWireTransfersInternational() {
        return this.dto.hasWireTransfersInternational;
    }

    public get hasWireTransfersDli() {
        return this.dto.hasWireTransfersDli;
    }

    public get changedWireTransfersDliEntitlements() {
        return this.dto.changedWireTransfersDliEntitlements;
    }

    public get changedWireTransfersDliUserLimits() {
        return this.dto.changedWireTransfersDliUserLimits;
    }

    public get hasStopPayment() {
        return this.dto.hasStopPayment;
    }

    public get hasIntegratedServices() {
        return this.dto.hasIntegratedServices;
    }

    public get changedIntegratedServices() {
        return this.dto.changedIntegratedServices;
    }

    public get hasReceivables() {
        return this.dto.hasReceivables;
    }

    public get hasAccountReconciliationReporting() {
        return this.dto.hasAccountReconciliationReporting;
    }

    public createDefault(): this {
        return new CompanyUserProductFeatureSummary(
            defaultCompanyUserProductFeatureSummary
        ) as this;
    }
}
